import { HtmlParser } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { InvoiceService } from '../invoice.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { HttpClient } from '@angular/common/http';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';


@Component({
  selector: 'app-preview-invoice',
  templateUrl: './preview-invoice.component.html',
  styleUrls: ['./preview-invoice.component.scss']
})
export class PreviewInvoiceComponent extends FeaturesBaseComponent implements OnInit {
  invoiceId: number;
  preview;
  dataLocalUrl: any;
  constructor(private activeRoute: ActivatedRoute, private invoiceService: InvoiceService, private http: HttpClient) {
    super();
    this.invoiceId = this.activeRoute.snapshot.params.id;
    
    this.invoiceService.getInvoicePdf(this.invoiceId).subscribe(res =>{
      let data: any = res
      var file = new Blob([data], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(file);
      // set preview url
      this.dataLocalUrl = fileURL;
    })  
    }

    
  




  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy():void{
    super.ngOnDestroy()
  }
}
